var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMetrics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_metrics",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "speed",
    d: "M128.579,180.751a1,1,0,0,1-.543-.16,11,11,0,1,1,11.945,0,1,1,0,0,1-.544.16ZM127.646,165a8.984,8.984,0,0,0,1.237,13.747h10.252A8.994,8.994,0,1,0,127.646,165Zm4.609,12.28a1,1,0,1,1,0-2h3.588a1,1,0,1,1,0,2Zm-.921-5.917a2.676,2.676,0,0,1,3.724-2.463l2.225-2.225a5.706,5.706,0,0,0-8.962,4.688,1,1,0,1,1-2,0,7.708,7.708,0,0,1,15.417,0,1,1,0,0,1-2,0,5.676,5.676,0,0,0-1.037-3.277l-2.229,2.229a2.676,2.676,0,1,1-5.139,1.048Zm2,0a.676.676,0,1,0,.676-.676A.677.677,0,0,0,133.334,171.365Z",
    transform: "translate(-122.009 -158.56)",
    fill: "#222a41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetrics);
export default __webpack_public_path__ + "static/media/icon_metrics.9693ae6d.svg";
export { ForwardRef as ReactComponent };